export default class DateRange {
  public from!: string | null
  public to!: string | null

  public constructor (from: string | null, to: string | null) {
    this.from = from
    this.to = to
  }
}
